import React from 'react';
import "./css/NoContentPopup.css";

function NoContentPopup(props) {
     return (
          <div className={props.nothingAvailable == true ? 'noContentPopup' : "noContentPopupOFF"}>
               <p>{props.text}</p>
          </div>
     )
}

export default NoContentPopup
